import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from './auth';

const PrivateRoute = ({ children, requiredPermission = null, allowedRoles = [] }) => {
    const authenticated = isAuthenticated();
    const userRole = getUserRole();

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check role-based access
    if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
        return <Navigate to="/admin/dashboard" replace />;
    }



    return children;
};

export default PrivateRoute;